// store/actionTypes/moduleActionTypes.js

export const FETCH_MODULES_REQUEST = 'FETCH_MODULES_REQUEST';
export const FETCH_MODULES_SUCCESS = 'FETCH_MODULES_SUCCESS';
export const FETCH_MODULES_FAILURE = 'FETCH_MODULES_FAILURE';

export const ADD_MODULE_REQUEST = 'ADD_MODULE_REQUEST';
export const ADD_MODULE_SUCCESS = 'ADD_MODULE_SUCCESS';
export const ADD_MODULE_FAILURE = 'ADD_MODULE_FAILURE';

export const UPDATE_MODULE_REQUEST = 'UPDATE_MODULE_REQUEST';
export const UPDATE_MODULE_SUCCESS = 'UPDATE_MODULE_SUCCESS';
export const UPDATE_MODULE_FAILURE = 'UPDATE_MODULE_FAILURE';

export const DELETE_MODULE_REQUEST = 'DELETE_MODULE_REQUEST';
export const DELETE_MODULE_SUCCESS = 'DELETE_MODULE_SUCCESS';
export const DELETE_MODULE_FAILURE = 'DELETE_MODULE_FAILURE';
